import { render, staticRenderFns } from "./receivableLedger.vue?vue&type=template&id=3f50acce&scoped=true"
import script from "./receivableLedger.vue?vue&type=script&lang=js"
export * from "./receivableLedger.vue?vue&type=script&lang=js"
import style0 from "./receivableLedger.vue?vue&type=style&index=0&id=3f50acce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50acce",
  null
  
)

export default component.exports